export enum SearchType {
    productType = 'productType',
    customer = 'customer',
    client = 'client'
}
